export function pageView(page, title) {
	if (window._mtm) {
		window._mtm.push({
			event: "gatsby-route-change",
			virtualPageURL: page,
			virtualPageTitle: title,
		});
	}
}
